import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import ConfirmDialog from 'components/confirm-dialog';
import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { ProductWizardStep } from 'pages/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'pages/menu/components/product-wizard/use-product-wizard-flow';

import { BodyComponent } from '../body-component';

export const UnsavedChangesDialog = () => {
  const { formatMessage } = useIntl();

  const { goToPreviousStep, currentFlowStep } = useProductWizardFlow();

  const {
    showCloseDialog,
    setShowCloseDialog,
    restoreSlotsSelectionSnapshot,
    clearSlotsSelectionSnapshot,
  } = useProductWizardContext();

  const shouldShowDialog =
    showCloseDialog && currentFlowStep.step === ProductWizardStep.ProductCustomization;

  const heading = formatMessage({ id: 'unsavedChangesModalHeader' });
  const content = formatMessage({ id: 'unsavedChangesModalDescription' });

  const saveLabel = formatMessage({ id: 'saveChanges' });
  const discardLabel = formatMessage({ id: 'leaveWithoutSaving' });

  const onConfirm = useCallback(() => {
    setShowCloseDialog(false);
    clearSlotsSelectionSnapshot();
    goToPreviousStep();
  }, [goToPreviousStep, setShowCloseDialog, clearSlotsSelectionSnapshot]);

  const onCancel = useCallback(() => {
    restoreSlotsSelectionSnapshot();
    setShowCloseDialog(false);
    goToPreviousStep();
  }, [setShowCloseDialog, goToPreviousStep, restoreSlotsSelectionSnapshot]);

  return (
    <ConfirmDialog
      showDialog={shouldShowDialog}
      modalAppearanceEventMessage="Confirmation: Product Wizard - Discard Unsaved Changes"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={saveLabel}
      cancelLabel={discardLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
